import { SelectOptionValue } from '@tencent/udesign/dist';
import { FieldType, IConfigField } from '../model';

export const AUTO_TABLE_CUSTOM_VALUE_ALL = 'autoTableCustomValueAll';
// 获取 当启用全选模式 时的选中项
export const getCheckItem = (
  value: ReadonlyArray<SelectOptionValue>,
  newValue: ReadonlyArray<SelectOptionValue>,
  selectAllValue: ReadonlyArray<SelectOptionValue>
) => {
  const selectedList: ReadonlyArray<SelectOptionValue> = value;
  let checkItem: ReadonlyArray<SelectOptionValue> = selectedList;
  // 判断 筛选框中的值 是否存在 全选
  const isAll = selectedList.includes(AUTO_TABLE_CUSTOM_VALUE_ALL);
  const allLength = selectAllValue.length;
  // 代表上次更改 是否 为全选
  const isPrevSelectAll = newValue.length === allLength;
  // 代表这次是否为 不为全选
  const notNewSelectAll = selectedList.length !== allLength;
  // 根据 是否选中全选 进行判断
  if (isAll) {
    checkItem = selectAllValue;
    // 当上次选中为全选 而这次 不是全选 时  过滤 全选 选中项
    if (isPrevSelectAll && notNewSelectAll) {
      checkItem = selectedList.filter(
        (item: SelectOptionValue) => item !== AUTO_TABLE_CUSTOM_VALUE_ALL
      );
    }
  } else {
    // 当这次选中的值 为 全选长度减一 时
    // 代表已经是全选了
    if (selectedList.length === allLength - 1) {
      checkItem = selectAllValue;
    }
    // 当上一次为全选 这次不为全选
    if (isPrevSelectAll && notNewSelectAll) {
      // 当 这次 里面 不存在全选 代表 取消全部选中
      checkItem = [];
    }
  }
  return checkItem;
};
export const getLabel = <T>(
  isMultiple: boolean,
  selectAllLabel: string,
  fieldConfig: IConfigField<T>,
  newValue?: ReadonlyArray<SelectOptionValue> | SelectOptionValue,
  isSelectAll?: boolean
) => {
  //  当 newValue 为空时 返回null
  if (!newValue) {
    return null;
  }
  if (isMultiple && Array.isArray(newValue)) {
    // 当 使用全选 时 而且  newValue 中存在全选
    if (isSelectAll && newValue.includes(AUTO_TABLE_CUSTOM_VALUE_ALL)) {
      return selectAllLabel;
    }
    // 当 newValue 是空数组 或者 筛选框数据还未获取到 时 返回 null
    if (newValue.length === 0 || !fieldConfig?.fieldOptExtension?.jsonData) {
      return null;
    }

    const label = newValue.map((item: string | number, index: number) => {
      const itemLabel = fieldConfig?.fieldOptExtension?.jsonData?.[item]?.label;
      return `${itemLabel}${index !== newValue.length - 1 ? ',' : ''}`;
    });
    return label;
  }
  // 处理 switch 模式
  if (fieldConfig.filter_type === FieldType.switch) {
    return newValue === '1' ? '是' : '否';
  }
  // 单选模式返回
  return fieldConfig?.fieldOptExtension?.jsonData?.[
    newValue as SelectOptionValue
  ].label;
};
